module.exports = __webpack_public_path__ + "img/o2.ef307c3e.jpg";